import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

export const BusIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M11 3C7.375 3 3 3.237 3 7V18C3 18.8849 3.39067 19.6716 4 20.2207V21.5C4 22.328 4.672 23 5.5 23C6.328 23 7 22.328 7 21.5V21H17V21.5C17 22.328 17.672 23 18.5 23C19.328 23 20 22.328 20 21.5V20.2207C20.6093 19.6716 21 18.8849 21 18V7C21 3.237 16.625 3 13 3H11ZM6 7H18C18.552 7 19 7.448 19 8V12C19 12.552 18.552 13 18 13H6C5.448 13 5 12.552 5 12V8C5 7.448 5.448 7 6 7ZM6.5 16C7.328 16 8 16.672 8 17.5C8 18.328 7.328 19 6.5 19C5.672 19 5 18.328 5 17.5C5 16.672 5.672 16 6.5 16ZM17.5 16C18.328 16 19 16.672 19 17.5C19 18.328 18.328 19 17.5 19C16.672 19 16 18.328 16 17.5C16 16.672 16.672 16 17.5 16Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

BusIcon.propTypes = {
  sx: PropTypes.object,
};

export default BusIcon;
